module.exports = __webpack_public_path__ + "static/image/font/pc/baemin-geullim-2.ver2_0_2.gif?ef1776fc";